import { gql } from 'apollo-angular';

/**
 * User schema
 */
export class GeocodeAddressSchema {
	/**
	 * All properties
	 */
	static readonly topLevelProperties = `
		latitude
		longitude
	`;

	static readonly getGeocodeAddress = gql`
		query GeocodeAddress ($address: AddressInput!) {
			geocodeAddress(address: $address) {
				${GeocodeAddressSchema.topLevelProperties}
			}
		}
	`;
}
